import React, {useEffect, useRef, useState} from 'react';
import {useSelector} from "react-redux";
import useAsyncErrorHandler from "./useAsyncErrorHandler";
import useLoading from "./useLoading";
import * as Async from "../features/async";

export default function useFetch(config = { returnInnerLoadingState: false }) {
    const isMounted = useRef(true);
    const setLoading = useLoading();
    const asyncErrorHandler = useAsyncErrorHandler();
    const credencial = useSelector(state => state.credencial);
    const [innerLoading, setInnerLoading] = useState(false);

    useEffect(() => {
        isMounted.current = true;

        return () => (isMounted.current = false);
    }, []);

    const fetchFunc = (url, params, onSuccess, onError, shouldFinishLoading = true) => {
        if (typeof onError === 'boolean') {
            shouldFinishLoading = onError;

            onError = undefined;
        }

        config.returnInnerLoadingState ? setInnerLoading(true) : setLoading(true);

        const asyncConfig = {...config};

        delete asyncConfig.returnInnerLoadingState;

        return Async.fetch(url, credencial, params, asyncConfig)
            .then(data => {
                if (isMounted.current) {
                    onSuccess && onSuccess(data);

                    return data;
                }
            })
            .catch(error => {
                onError ? onError(error, asyncErrorHandler) : asyncErrorHandler(error);
            })
            .finally(() => {
                config.returnInnerLoadingState ? setInnerLoading(false) : (shouldFinishLoading && setLoading(false));
            });
    };

    return !config.returnInnerLoadingState ? fetchFunc : [fetchFunc, innerLoading];
}